import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandMore';
import ExpandMore from '@mui/icons-material/ChevronRight';
import { Collapse, ListItem, ListItemButton, Link } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../routes/helpers/HAppRoutes';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HAppNavigation from '../../helpers/HAppNavigation';
import { CSSProperties } from 'react';
import IAppNavigation from '../../interfaces/IAppNavigation';
import { TFunction } from 'i18next';

type AppNavigationDrawerProps = {
	navigationConfig: IAppNavigation[] | null | undefined;
	onClose: () => void;
};

const AppNavigationDrawer = (props: AppNavigationDrawerProps) => {
	const { navigationConfig, onClose } = props;
	const location = useLocation();

	const { t } = useTranslation();
	// Mise à jour du menu actif : on retrouve la route qui correspond avec le menu puis on active la sélection sur tous les parents.
	const navigationConfigUpdated = useMemo(() => {
		if (!navigationConfig || !location.pathname) return navigationConfig;
		return HAppNavigation.updateNavigationActive(navigationConfig, location.pathname);
	}, [navigationConfig, location.pathname]);

	return (
		<>
			{navigationConfigUpdated ? (
				<List>
					{navigationConfigUpdated.map((menuItem: IAppNavigation, index: number) => {
						return (
							<AppNavigationDrawerItem
								key={'0_' + index}
								level={0}
								menuItem={menuItem}
								t={t}
								onClose={onClose}
							/>
						);
					})}
				</List>
			) : (
				''
			)}
		</>
	);
};

type AppNavigationDrawerItemProps = {
	menuItem: IAppNavigation;
	level: number;
	t: TFunction;
	onClose: () => void;
	style?: CSSProperties;
};

const AppNavigationDrawerItem = (props: AppNavigationDrawerItemProps) => {
	const { menuItem, level, t, onClose } = props;
	const navigate = useNavigate();
	const handleOpen = () => {
		setOpen(!open);
	};

	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (menuItem.isActive || (menuItem.children && menuItem.children.some((x) => x.isActive))) {
			setOpen(true);
		} else {
			setOpen(false);
		}
	}, [menuItem]);

	let extendStyle = {};
	if (level > 0) {
		extendStyle = { paddingLeft: `${level * 58}px` };
	}

	const linkTo = () => {
		const routePath =
			HAppRoutes.getPath(menuItem.routeTag ?? '', menuItem.routeParams ?? null) +
			`${menuItem.routeGet ? '?' + menuItem.routeGet : ''}`;
		navigate(routePath);
		onClose();
	};

	return (
		<>
			{typeof menuItem.visible === 'undefined' || menuItem.visible === true ? (
				<>
					<ListItemButton
						id={'user-navigation-menu-' + menuItem.id}
						style={{ ...props.style, ...extendStyle }}
						selected={menuItem.isActive}
						key={menuItem.id}
						component={menuItem.type === 'item' ? Link : ListItem}
						onClick={() => {
							menuItem.children ? handleOpen() : linkTo();
							menuItem.type === 'item' ? linkTo() : null;
						}}
					>
						{menuItem.icon ? <ListItemIcon>{menuItem.icon}</ListItemIcon> : ''}
						<ListItemText primary={t(menuItem.title)} />
						{menuItem.type === 'collapse' ? <>{open ? <ExpandLess /> : <ExpandMore />}</> : ''}
					</ListItemButton>
					{menuItem.children ? (
						<Collapse in={open}>
							{menuItem.children.map((child, index) => {
								return (
									<AppNavigationDrawerItem
										key={level + '_' + index}
										menuItem={child}
										onClose={onClose}
										level={level + 1}
										t={t}
									/>
								);
							})}
						</Collapse>
					) : (
						''
					)}
				</>
			) : (
				''
			)}
		</>
	);
};

export default AppNavigationDrawer;
